// Get the header
var header = document.getElementById("masthead");

if (typeof(header) != 'undefined' && header != null) {
	// STICKY NAV - unfortunately found here https://www.w3schools.com/howto/howto_js_sticky_header.asp 
	// When the user scrolls the page, execute myFunction
	window.onscroll = function() { stickyFunction() };

	// Get the offset position of the navbar
	var sticky = header.offsetTop;

	// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
	function stickyFunction() {
	  if (window.pageYOffset > sticky) {
	    header.classList.add("sticky");
	  } else {
	    header.classList.remove("sticky");
	  }
	} 

}

$ = jQuery;



$(function() {


	$('.carousel-toggle').on('click', function(e) {
		e.preventDefault();

		$(this).parent('.carousel').find('.active').addClass('working');
		$(this).parents('.slideshow-container').find('.dots-nav .dot.active').addClass('working');
		$workingSlide = $(this).parent('.carousel').find('.working');
		$workingDot = $(this).parents('.slideshow-container').find('.dots-nav .dot.working');

		// a bunch of set up for next/prev slides
		if ($workingSlide.next('.slide').length) {
			$workingSlide.next('.slide').addClass('next');		
			$workingDot.next('.dot').addClass('next')		
		} else {
			$(this).parent('.carousel').find('.frame1').addClass('next');
			$(this).parents('.slideshow-container').find('.dots-nav .dot.dot1').addClass('next');
		}

		if ($workingSlide.prev('.slide').length) {
			$workingSlide.prev('.slide').addClass('previous');
			$workingDot.prev('.dot').addClass('previous')		
		} else {
			$(this).parent('.carousel').find('li').last().addClass('previous');
			$(this).parents('.slideshow-container').find('.dots-nav .dot').last().addClass('previous');
		}

		$nextSlide = $(this).parent('.carousel').find('.next');
		$prevSlide = $(this).parent('.carousel').find('.previous');

		$nextDot = $(this).parents('.slideshow-container').find('.dots-nav .dot.next');
		$prevDot = $(this).parents('.slideshow-container').find('.dots-nav .dot.previous');

		// here's where the click is triggered
		if ($(this).hasClass('slide-next')) {
			// console.log('next');
			$workingSlide.animate({left:'-100%'}, 300).removeClass('active');
			$nextSlide.animate({left:'0'}, 300).addClass('active');

			$workingDot.removeClass('active');
			$nextDot.addClass('active');

		} else {
			// console.log('prev');
			$workingSlide.animate({left:'100%'}, 300).removeClass('active');
			$prevSlide.animate({left:'0'}, 300).addClass('active');

			$workingDot.removeClass('active');
			$prevDot.addClass('active');
		}

		$nextSlide.removeClass('next').removeAttr('style');
		$prevSlide.removeClass('previous').removeAttr('style');

		$nextDot.removeClass('next');
		$prevDot.removeClass('previous')

		//      setTimeout(function() {
		$workingSlide.removeClass('working').removeAttr('style');
		//      }, 300);
		$workingDot.removeClass('working');
	});

});






$(function() {
////Openings Menu - Start
	jQuery('#openings-toggle').on('click', function() { 
		jQuery('#openings-list').toggle('slow').addClass('flash-bg'); 
		jQuery('#openings-toggle').fadeOut();
		jQuery('html, body').animate({ scrollTop: jQuery('#openings-list').offset().top}); 
		return false; 
	});


	////Departments Menu - Start
	// jQuery('.departments-toggle').on('click', function(e){ 
	// 	e.preventDefault();
		// console.log(jQuery('#departments-list').height());

		// if(jQuery('#departments-list').height() > 0){ 
		// 	jQuery('#departments-list').animate({ height: 0 }, 500, function(){  }); 		
		// } else { 
		// 	jQuery('#departments-list').animate({ height: jQuery('#departments-list').get(0).scrollHeight }, 500, function(){ jQuery(this).height('auto'); }); 		
		// }
	// return false; });

	////Departments Filter - Start
	$('.people-filter').on('click', function(){ 
		var showMe = jQuery(this).data('id'); 
		if(showMe == 'all'){
			jQuery('#employee-list li').show(); 
		} else {
			jQuery('#employee-list li').hide(); 
			jQuery('.'+showMe).show();  
		}

		if ($(this).hasClass('active')) {
			return;
		} else {
			$('.people-filter.active').removeClass('active');
			$(this).addClass('active');
		}

		// jQuery('.people-filter').css('color', '#fff'); jQuery(this).css('color', '#afbb34');
		// jQuery('#departments-list').animate({ height: 0 }, 500, function(){  }); 
		// jQuery('html, body').animate({ scrollTop: jQuery('#departments-list').offset().top});
	return false; });
});




// PERVASIVE CTA
$(function() {

    // get full height of BODY
    // position #halfway-marker halfway from the top of the page
    $bodyHeight = $('body').height();
    $halfBodyHeight = $bodyHeight / 2;
    $('#halfway-marker').css('top',$halfBodyHeight + 'px');

    /**********************************/
    /* PRIVACY NOTICE ACKNOWLEDGEMENT */
    /**********************************/
    var ctaCookie = Cookies.get("STYXKEY_ctaModalAcknowledged");
    
    if (ctaCookie == null) {
        $('#cta-notice').fadeIn();
    }

    $('body').on('click', '#close-cta-notice', function(e) {
        e.preventDefault();
        // Cookies.set('STYXKEY_ctaModalAcknowledged','1', { expires: 365, path: '' } ); // number of days value for expiration
        // Cookies.set('STYXKEY_ctaModalAcknowledged','1', { expires: 1 } ); // remove path to make cookie valid across the entire site
        Cookies.set('STYXKEY_ctaModalAcknowledged','1'); // remove path to make cookie valid across the entire site
        $('#cta-notice').fadeOut();
    });

    $('body').on('click', '#cta-acknowledge', function(e) {
        e.preventDefault();
        Cookies.set('STYXKEY_ctaModalAcknowledged','1'); 
        $('#cta-notice').fadeOut();
    });

    $('body').on('click', '.frm_button_submit:not(.frm_final_submit)', function(e) {
    	$('#cta-notice').addClass('embiggen');
    	$('#cta-acknowledge').fadeOut();
    });

    // ANIMATION
    setTimeout(function() {
        AOS.init();
    }, 400);
});